/**
 * ========================================================
 * Description: A web control for editing a text field which
 *              can contain html
 * Creation Date: ?
 * Author: ?
 * ========================================================
 **/

function removeHtmlHiddenContent(html) {
    //Wanted to do this server-side like using shared_model_utils.remove_invalid_html_from_field, but html sections are very difficult to parse without a proper DOM parser, and serverside is old so even a DOM parsing node_module might break with new tags, so I have no choice but to do this client-side, I feel:
    
    // Create a temporary container element (not appended to the DOM)
    var container = document.createElement('div');
    container.innerHTML = html;

    function removeHidden(node) {
        if (node.nodeType === 1) { // Element node
            var style = node.getAttribute('style');
            if (style && (/display\s*:\s*none|visibility\s*:\s*hidden/i).test(style)) {
                node.parentNode.removeChild(node);
                return; // Node removed, no need to check its children
            }
            var children = node.childNodes;
            // Iterate backwards to safely remove nodes
            for (var i = children.length - 1; i >= 0; i--) {
                removeHidden(children[i]);
            }
        }
    }

    removeHidden(container);

    var cleanedHtml = container.innerHTML;

    // Clean up the container reference
    container = null;

    return cleanedHtml;
}

// --- DOMPurify strict table config ---
const PURIFY_CONFIG = {
    // 1) only these tags
    ALLOWED_TAGS: [
        'p', 'br', 'ul', 'ol', 'li',
        'b', 'strong', 'i', 'em', 'u', 'a',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'blockquote', 'pre', 'code',
        'img', 'table', 'thead', 'tbody', 'tr', 'td', 'th'
    ],
    // 2) only these attributes (style we’ll filter in the hook)
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style'],
    // 3) forbid any event handlers
    FORBID_ATTR: ['on.*'],
    // 4) no data- attributes
    ALLOW_DATA_ATTR: false
};

// 5) hook to prune style declarations
DOMPurify.addHook('uponSanitizeAttribute', function (node, data) {
    // drop any layout‑related attribute
    const badAttrs = ['width', 'height', 'border', 'cellpadding', 'cellspacing', 'align', 'valign', 'class'];
    if (badAttrs.includes(data.attrName.toLowerCase())) {
        return false;
    }

    // if this is style="…", filter to only safe text styles
    if (data.attrName === 'style') {
        // split on ;, keep only these props
        const keep = /^(font-size|font-family|color|text-align)\s*:/i;
        const filtered = data.attrValue
            .split(';')
            .map(s => s.trim())
            .filter(s => keep.test(s))
            .join('; ');
        if (filtered) {
            data.attrValue = filtered;
            return true;
        }
        // nothing safe left, drop the style entirely
        return false;
    }
});


function sanitizeHtml(html) {
    html = removeHtmlHiddenContent(html); //DOMPurify could probably do this, but might as well keep our old code so we know nothing sneaks back in.
    return DOMPurify.sanitize(html, PURIFY_CONFIG);
}

var EditorHtml = React.createClass({
    render: function(){
        return <div ref="domElement" />;
    },
    componentDidMount:function()
    {
        var context = this;
        context.oldValue = this.props.value;
        var sanitized = sanitizeHtml(this.props.value);
        $(this.refs.domElement).html(sanitized).tinymce({
            readonly: this.props.readOnly,
            plugins: "textcolor",
            invalid_styles: 'color font-size font-family',
            toolbar: 'undo redo | styleselect | bold italic backcolor | bullist | link image',
            textcolor_map: [
                "ffff00", "Yellow"
            ],
            menubar: false,
            setup: function (ed) {
                ed.on('change', function (e) {
                    var content = ed.getContent();
                    content = sanitizeHtml(content);
                    if (context.oldValue == content) {
                        return;
                    }
                    context.oldValue = content;
                    context.props.onChange(content);
                    context.props.onBlur();
                });
            }
        });

        if (sanitized !== context.oldValue) {
            context.oldValue = sanitized;
            context.props.onChange(sanitized);
            context.props.onBlur();
        }
    }
});
